document.addEventListener("DOMContentLoaded", e => {
    // const option = document.querySelectorAll(".filter__checkbox input");
    const filter = document.querySelectorAll(".filter");
    const optionCounter = document.querySelectorAll(".filter__number");
    let options = [];
    const radioFilter = document.querySelectorAll(".filter__radio-wrap");
    const answer = document.querySelectorAll(".filter__checkbox input");

    openFilter()

    chooseFilter()

    function chooseFilter() {
        for (let index = 0; index < radioFilter.length; index++) {
            for (let i = 0; i < answer.length; i++) {

                answer[i].onclick = function () {
                    let selectedItem = this.closest('.filter__radio-wrap').querySelector('.filter_selected'),
                        label = this.closest('.filter__radio-wrap').querySelector('.filter__type');

                    selectedItem.innerHTML = this.parentNode.querySelector('.filter__name').textContent
                
                    label.style.cssText =
                        'font-size: 7px; top: 6px; color: #9d9d9d; text-transform: uppercase';
                }
            }
        }
    }
    
    function openFilter() {
        for (let index = 0; index < filter.length; index++) {
          
            filter[index].onclick = function () {
                filter[index].nextElementSibling.classList.toggle("active")      
                filter[index].classList.toggle("active") 
            }
            document.addEventListener('click', function(e) {
                if (!filter[index].contains(e.target) && !filter[index].nextElementSibling.contains(e.target))   {
                    filter[index].nextElementSibling.classList.remove("active")   
                    filter[index].classList.remove("active") 
                }
            });
        }
    }

    getFilterOptions()
    
    function getFilterOptions() {
       
        for (let index = 0; index < filter.length; index++) {
            const option = filter[index].nextElementSibling.querySelectorAll(".filter__checkbox input:not(.js-all-checkbox)")
            let elem = filter[index].nextElementSibling.querySelectorAll(".filter__checkbox input:checked:not(.js-all-checkbox)").length;
            for (let i = 0; i < option.length; i++) {
                if (elem > 0) {
                    optionCounter[index].classList.add("active")  
                    optionCounter[index].innerHTML = "(" + elem + ")"
                } else {
                    optionCounter[index].classList.remove("active")  
                }
                option[i].addEventListener('change', function(e) {
                
                    option[i].checked ? elem++ : elem--
                    
                    if (elem > 0) {
                        optionCounter[index].classList.add("active")  
                        optionCounter[index].innerHTML = "(" + elem + ")"
                    } else {
                        optionCounter[index].classList.remove("active")  
                    }
                })
            }
        }
    }    
})
